import React from 'react'
import { Col } from 'react-bootstrap'
import { Box, SpanStyled, } from '../../Styled/Elements'
import { useTranslation } from 'react-i18next'

const PrMoreDetail7 = () => {
    const { t } = useTranslation();
    
    return (
        <>
            <Col lg={12} className='sthDesc mb-2'>
                <Box className="smallTitleHeading">
                    {t('OverValues')}
                </Box>
                <SpanStyled size='15px' className='projectDesc'>
                    {t('projectModText7S')}
                </SpanStyled>
            </Col>
            
        </>
    )
}

export default PrMoreDetail7
